(function () {
  var initializedRoots = new WeakSet();
  var initializedLoadMoreLists = new WeakSet();

  function toNumber(value, fallback) {
    var number = parseInt(value, 10);
    return Number.isNaN(number) ? fallback : number;
  }

  function focusElement(element) {
    if (!element || !element.focus) return;

    try {
      element.focus({ preventScroll: true });
    } catch (error) {
      element.focus();
    }
  }

  function pauseMedia(root) {
    if (typeof window.pauseAllMedia === 'function') {
      window.pauseAllMedia();
      return;
    }

    root.querySelectorAll('video').forEach(function (video) {
      video.pause();
    });
  }

  function sortObjectReviewCards(list, cards) {
    if (!list || !cards || !cards.length) return cards || [];

    var sortedCards = cards.slice().sort(function (firstCard, secondCard) {
      var firstHasMedia = firstCard.dataset.objectReviewHasMedia === 'true' ? 1 : 0;
      var secondHasMedia = secondCard.dataset.objectReviewHasMedia === 'true' ? 1 : 0;
      if (firstHasMedia !== secondHasMedia) return secondHasMedia - firstHasMedia;

      var firstDate = toNumber(firstCard.dataset.objectReviewDate, 0);
      var secondDate = toNumber(secondCard.dataset.objectReviewDate, 0);
      if (firstDate !== secondDate) return secondDate - firstDate;

      return toNumber(firstCard.dataset.objectReviewOriginalIndex, 0) - toNumber(secondCard.dataset.objectReviewOriginalIndex, 0);
    });

    sortedCards.forEach(function (card) {
      list.appendChild(card);
    });

    return sortedCards;
  }

  function setupMediaCarousels(root) {
    root.querySelectorAll('[data-object-review-media-carousel]').forEach(function (carousel) {
      if (carousel.dataset.objectReviewCarouselReady === 'true') return;

      var strip = carousel.querySelector('[data-object-review-media-strip]');
      var previousButton = carousel.querySelector('[data-object-review-media-scroll="prev"]');
      var nextButton = carousel.querySelector('[data-object-review-media-scroll="next"]');
      if (!strip || !previousButton || !nextButton) return;

      carousel.dataset.objectReviewCarouselReady = 'true';

      function updateScrollButtons() {
        var hasOverflow = strip.scrollWidth > strip.clientWidth + 2;
        var atStart = strip.scrollLeft <= 2;
        var atEnd = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 2;
        var canScrollPrevious = hasOverflow && !atStart;
        var canScrollNext = hasOverflow && !atEnd;

        previousButton.disabled = !canScrollPrevious;
        nextButton.disabled = !canScrollNext;
        previousButton.style.visibility = canScrollPrevious ? 'visible' : 'hidden';
        nextButton.style.visibility = canScrollNext ? 'visible' : 'hidden';
        previousButton.style.pointerEvents = canScrollPrevious ? 'auto' : 'none';
        nextButton.style.pointerEvents = canScrollNext ? 'auto' : 'none';
      }

      function scrollStrip(direction) {
        var distance = Math.max(strip.clientWidth * 0.72, 140);
        var delta = direction === 'next' ? distance : -distance;

        if (typeof strip.scrollBy === 'function') {
          strip.scrollBy({ left: delta, behavior: 'smooth' });
        } else {
          strip.scrollLeft += delta;
        }

        window.setTimeout(updateScrollButtons, 260);
      }

      var lastScrollAt = 0;

      function handleScrollControl(direction, event) {
        if (event) event.preventDefault();

        var now = Date.now();
        if (now - lastScrollAt < 180) return;

        lastScrollAt = now;
        scrollStrip(direction);
      }

      previousButton.addEventListener('click', function (event) {
        handleScrollControl('prev', event);
      });
      previousButton.addEventListener('pointerup', function (event) {
        handleScrollControl('prev', event);
      });
      previousButton.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        handleScrollControl('prev', event);
      });

      nextButton.addEventListener('click', function (event) {
        handleScrollControl('next', event);
      });
      nextButton.addEventListener('pointerup', function (event) {
        handleScrollControl('next', event);
      });
      nextButton.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        handleScrollControl('next', event);
      });

      carousel.addEventListener('click', function (event) {
        var control = event.target && event.target.closest ? event.target.closest('[data-object-review-media-scroll]') : null;
        if (!control || !carousel.contains(control)) return;
        handleScrollControl(control.getAttribute('data-object-review-media-scroll'), event);
      });

      carousel.addEventListener('pointerup', function (event) {
        var control = event.target && event.target.closest ? event.target.closest('[data-object-review-media-scroll]') : null;
        if (!control || !carousel.contains(control)) return;
        handleScrollControl(control.getAttribute('data-object-review-media-scroll'), event);
      });

      strip.addEventListener('scroll', updateScrollButtons, { passive: true });
      window.addEventListener('resize', updateScrollButtons, { passive: true });
      window.setTimeout(updateScrollButtons, 60);
    });
  }

  function setupObjectReviewLoadMore(root) {
    if (!root) return;

    var list = root.querySelector('[data-object-reviews-list]');
    if (!list || initializedLoadMoreLists.has(list)) return;

    var cards = Array.prototype.slice.call(list.querySelectorAll('[data-object-review-card]'));
    var button = root.querySelector('[data-object-reviews-load-more]');
    var wrapper = root.querySelector('[data-object-reviews-load-more-wrap]');
    if (!cards.length) return;

    cards = sortObjectReviewCards(list, cards);

    initializedLoadMoreLists.add(list);

    var initialCount = Math.max(toNumber(list.dataset.objectReviewsInitialCount, 10), 1);
    var stepCount = Math.max(toNumber(list.dataset.objectReviewsStepCount, 5), 1);

    if (!button || cards.length <= initialCount) {
      cards.forEach(function (card) {
        card.hidden = false;
      });

      if (button) button.hidden = true;
      if (wrapper) wrapper.hidden = true;
      return;
    }

    var visibleCount = Math.min(initialCount, cards.length);

    function updateReviewsVisibility() {
      cards.forEach(function (card, index) {
        card.hidden = index >= visibleCount;
      });

      var hasMoreReviews = visibleCount < cards.length;
      button.hidden = !hasMoreReviews;
      button.disabled = !hasMoreReviews;
      button.setAttribute('aria-expanded', hasMoreReviews ? 'false' : 'true');

      if (wrapper) wrapper.hidden = !hasMoreReviews;
    }

    button.addEventListener('click', function () {
      visibleCount = Math.min(visibleCount + stepCount, cards.length);
      updateReviewsVisibility();
    });

    updateReviewsVisibility();
  }

  function setupObjectReviewsModal(root) {
    if (!root || initializedRoots.has(root)) return;

    setupMediaCarousels(root);
    initializedRoots.add(root);

    var modal = root.querySelector('[data-object-review-modal]');
    if (!modal) return;

    var dialog = modal.querySelector('[role="dialog"]');
    var triggers = root.querySelectorAll('[data-object-review-trigger]');
    var mediaPanels = Array.prototype.slice.call(modal.querySelectorAll('[data-object-review-media-panel]'));
    var detailPanels = Array.prototype.slice.call(modal.querySelectorAll('[data-object-review-detail]'));
    var closeButtons = modal.querySelectorAll('[data-object-review-close]');
    var prevMediaButton = modal.querySelector('[data-object-review-prev-media]');
    var nextMediaButton = modal.querySelector('[data-object-review-next-media]');
    var prevReviewButton = modal.querySelector('[data-object-review-prev-review]');
    var nextReviewButton = modal.querySelector('[data-object-review-next-review]');
    var mediaCounter = modal.querySelector('[data-object-review-media-counter]');
    var reviewCounter = modal.querySelector('[data-object-review-review-counter]');
    var swipeArea = modal.querySelector('[data-object-review-swipe]');
    var state = {
      reviewIndex: 0,
      mediaIndex: 0,
      opener: null,
      touchStartX: 0,
      touchStartY: 0
    };

    if (!dialog || !triggers.length || !mediaPanels.length) return;

    function getPanel(index) {
      return mediaPanels[index] || null;
    }

    function getDetails(index) {
      return detailPanels[index] || null;
    }

    function getSlides(index) {
      var panel = getPanel(index);
      if (!panel) return [];
      return Array.prototype.slice.call(panel.querySelectorAll('[data-object-review-media-slide]'));
    }

    function normalizeReviewIndex(index) {
      if (!mediaPanels.length) return 0;
      return (index + mediaPanels.length) % mediaPanels.length;
    }

    function normalizeMediaIndex(index, slides) {
      if (!slides.length) return 0;
      if (index < 0) return slides.length - 1;
      if (index >= slides.length) return 0;
      return index;
    }

    function updateButtons(slides) {
      var oneReview = mediaPanels.length <= 1;
      var oneMedia = slides.length <= 1;

      if (prevReviewButton) prevReviewButton.disabled = oneReview;
      if (nextReviewButton) nextReviewButton.disabled = oneReview;
      if (prevMediaButton) prevMediaButton.disabled = oneReview && oneMedia;
      if (nextMediaButton) nextMediaButton.disabled = oneReview && oneMedia;
    }

    function updateCounters(slides) {
      if (mediaCounter) {
        mediaCounter.textContent = slides.length > 1 ? (state.mediaIndex + 1) + ' / ' + slides.length : '';
        mediaCounter.hidden = slides.length <= 1;
      }

      if (reviewCounter) {
        reviewCounter.textContent = 'Review ' + (state.reviewIndex + 1) + ' of ' + mediaPanels.length;
      }
    }

    function showMedia(index) {
      var slides = getSlides(state.reviewIndex);
      state.mediaIndex = normalizeMediaIndex(index, slides);

      slides.forEach(function (slide, slideIndex) {
        slide.hidden = slideIndex !== state.mediaIndex;
      });

      updateButtons(slides);
      updateCounters(slides);
      pauseMedia(modal);
    }

    function showReview(index, mediaIndex) {
      state.reviewIndex = normalizeReviewIndex(index);

      mediaPanels.forEach(function (panel, panelIndex) {
        panel.hidden = panelIndex !== state.reviewIndex;
      });

      detailPanels.forEach(function (panel, panelIndex) {
        panel.hidden = panelIndex !== state.reviewIndex;
      });

      showMedia(typeof mediaIndex === 'number' ? mediaIndex : 0);
    }

    function showNextReview(mediaIndex) {
      showReview(state.reviewIndex + 1, typeof mediaIndex === 'number' ? mediaIndex : 0);
    }

    function showPreviousReview(useLastMedia) {
      var previousIndex = normalizeReviewIndex(state.reviewIndex - 1);
      var previousSlides = getSlides(previousIndex);
      showReview(previousIndex, useLastMedia ? previousSlides.length - 1 : 0);
    }

    function showNextMedia() {
      var slides = getSlides(state.reviewIndex);
      if (state.mediaIndex < slides.length - 1) {
        showMedia(state.mediaIndex + 1);
      } else {
        showNextReview(0);
      }
    }

    function showPreviousMedia() {
      if (state.mediaIndex > 0) {
        showMedia(state.mediaIndex - 1);
      } else {
        showPreviousReview(true);
      }
    }

    function openModal(reviewIndex, mediaIndex, opener) {
      state.opener = opener || null;
      modal.hidden = false;
      document.body.classList.add('moko-object-review-modal-open');
      showReview(reviewIndex, mediaIndex);
      focusElement(dialog);
    }

    function closeModal() {
      if (modal.hidden) return;

      modal.hidden = true;
      document.body.classList.remove('moko-object-review-modal-open');
      pauseMedia(modal);
      focusElement(state.opener);
      state.opener = null;
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openModal(
          toNumber(trigger.dataset.reviewIndex, 0),
          toNumber(trigger.dataset.mediaIndex, 0),
          trigger
        );
      });
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    if (prevMediaButton) prevMediaButton.addEventListener('click', showPreviousMedia);
    if (nextMediaButton) nextMediaButton.addEventListener('click', showNextMedia);
    if (prevReviewButton) prevReviewButton.addEventListener('click', function () { showPreviousReview(false); });
    if (nextReviewButton) nextReviewButton.addEventListener('click', function () { showNextReview(0); });

    modal.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        showNextMedia();
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showPreviousMedia();
      }
    });

    if (swipeArea) {
      swipeArea.addEventListener('touchstart', function (event) {
        var touch = event.changedTouches[0];
        state.touchStartX = touch.clientX;
        state.touchStartY = touch.clientY;
      }, { passive: true });

      swipeArea.addEventListener('touchend', function (event) {
        var touch = event.changedTouches[0];
        var deltaX = touch.clientX - state.touchStartX;
        var deltaY = touch.clientY - state.touchStartY;

        if (Math.abs(deltaX) < 42 || Math.abs(deltaX) < Math.abs(deltaY)) return;

        if (deltaX < 0) {
          showNextMedia();
        } else {
          showPreviousMedia();
        }
      }, { passive: true });
    }
  }

  function initObjectReviewsModals(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var reviewRoots = Array.prototype.slice.call(root.querySelectorAll('[data-object-reviews-modal-root]'));

    if (root.matches && root.matches('[data-object-reviews-modal-root]')) {
      reviewRoots.unshift(root);
    }

    reviewRoots.forEach(function (reviewRoot) {
      setupObjectReviewLoadMore(reviewRoot);
      setupObjectReviewsModal(reviewRoot);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initObjectReviewsModals(document);
    }, { once: true });
  } else {
    initObjectReviewsModals(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initObjectReviewsModals(event.target);
  });
})();
